<template>
  <ul class="floating">
    <li class="item hotline-show">
      <span class="left-float">&#xe823;</span>
      <div class="popup hotline">
        <p class="msg">客服热线：400-613-6188</p>
      </div>
    </li>
    <li class="item question-show"
        v-show="progress === 2 ">
      <span class="left-float">&#xe824;</span>
      <div class="popup question">
        <strong class="name">常见问题</strong>
        <div class="question-list"
             v-for="(item, index) in commonQuestion"
             :key="index">
          <p>问：{{ item.title }}</p>
          <p>答：{{ item.answer }}</p>
        </div>
      </div>
    </li>
    <li class="item attention-show">
      <span class="left-float">&#xe825;</span>
      <div class="popup attention">
        <p class="name">卡销宝：专注服务商用车经销商的数字营销专家</p>
        <div class="attention-bottom">
          <span>欢迎扫码关注</span>
          <figure>
            <img src="@/assets/qrcode.jpg"
                 alt="" />
          </figure>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    progress: {
      type: [Number, String],
      default: 1
    }
  },
  data () {
    return {
      // 常见问题列表
      commonQuestion: [
        {
          title: '标注地图有什么用？',
          answer: '标注地图后，将有助于购车用户更精准找到您的店铺位置。'
        },
        {
          title: '找不到我的经营品牌？',
          answer:
            '请优先检查商用分类是否选择正确，若仍未找到想要的品牌，请拨打 400-613-6188 客服电话，我们将第一时间为您解决！'
        },
        {
          title: '审核通过后，营业执照还有什么用？',
          answer:
            '审核通过后，营业执照将展示在网络店铺前台，可提高购车用户对店铺的公信度，进一步促进用户浏览、询价、购车等行为发生。'
        }
        // {
        //   id: 4,
        //   title: "标注地图有什么用？",
        //   answer: "标注地图后，将有助于购车用户更精准找到您的店铺位置。"
        // }
      ],
      // 滑过展示的浮窗
      showFloating: ''
    }
  },
  methods: {
    showFloat (val) {
      this.showFloating = val
    }
  }
}
</script>
<style lang="less" scoped>
.floating {
  z-index: 10;
  position: absolute;
  top: 230px;
  left: 50%;
  transform: translate(270px, 0);
  .item {
    position: relative;
    cursor: pointer;
    .left-float {
      display: block;
      text-align: center;
      width: 35px;
      height: 35px;
      line-height: 35px;
      border: 1px solid #e4e5e6;
      border-radius: 3px;
      margin-bottom: 30px;
      color: #17181a;
      font-family: 'dealer';
    }
    .popup {
      position: absolute;
      top: 0;
      left: 50px;
      z-index: 9;
      display: none;
      width: 280px;
      min-height: 40px;
      padding: 0 5px;
      box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.08);
      border: 1px solid #e4e5e6;
      background: #fff;
      color: #495060;
      font-size: 12px;
      &::after {
        content: '';
        width: 0;
        height: 0;
        border: 10px solid transparent;
        border-right-color: #fff;
        position: absolute;
        top: 10px;
        left: -10px;
        z-index: 10;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
      }
      &.hotline {
        .msg {
          padding: 0 5px;
          line-height: 40px;
          font-size: 14px;
        }
      }
      &.question,
      &.attention {
        padding: 10px;
        box-sizing: border-box;
      }
      &.question .name {
        text-align: center;
      }
      .attention-bottom {
        text-align: center;
        img {
          width: 120px;
          height: auto;
        }
      }

      .name {
        display: block;
        font-size: 14px;
        padding: 8px 0;
      }
      .question-list {
        p {
          font-size: 12px;
          &:first-child {
            margin-top: 8px;
            color: #0099ff;
          }
          &:last-child {
            margin-top: 5px;
          }
        }
      }
    }
    &:hover {
      .left-float {
        background: #25a6ff;
        border: #25a6ff solid 1px;
        color: #ffffff;
      }
      .popup {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FloatingWindow.vue